<template>
    <b-modal size="lg" id="signatureModal" hide-footer="" :title="`Edit ${mode}`">
        <b-overlay :show="hasMounted == false || is_saving">
            <div style="width: 100%;">
                <VueSignaturePad class="me-auto ms-auto" height="300px" width="300px" ref="signaturePad" />
            </div>
        </b-overlay>
        <div ref="svgParent" v-show="false">
            <!--<img :src="saved_data" alt="">-->
            <div v-html="saved_data" alt=""></div>
        </div>
        <div v-show="hasMounted" class=" p-2 d-flex">
            <!--<b-button @click="changeMode()" variant="success" class="ms-auto me-2">
                <span v-show="mode == 'signature'">Edit Initial</span>
                <span v-show="mode == 'initial'">Edit Signature</span>
            </b-button>-->
            <b-button @click="saveSignature(mode)" variant="primary" class="ms-auto me-2">Save {{mode}}</b-button>
            <b-button @click="$refs.signaturePad.clearSignature()" variant="danger" class="me-2">Reset</b-button>
            <b-button @click="$refs.signaturePad.undoSignature()" variant="warning" class="">Undo</b-button>
        </div>
    </b-modal>
</template>

<script>
import { userMethods, userState } from '@/state/helpers'
//import Swal from 'sweetalert2'
// eslint-disable-next-line
import svgToPath from 'svg-path-converter';
export default {
    data:() => ({
        hasMounted: false,
        is_saving: false,
        saved_data: null,
        mode: 'signature', // signature or initial
    }),
    computed:{
        ...userState,
    },
    methods:{
        ...userMethods,
        saveSignature(type){
            this.is_saving = true;
            let data = this.$refs.signaturePad.saveSignature('image/svg+xml');
            let encoded = data.data.split(",")[1];
            let decoded = atob(encoded);
            decoded = decoded.replace('<svg', `<svg id="hiddenSVG"`)
            this.saved_data = decoded;
            setTimeout(()=>{
                let svg_element = this.$refs.svgParent;
                const elements = svg_element.childNodes[0].children;
                /*elements[0].children.forEach( elem => {
                    console.log(elem.attributes);
                })*/
                const loop_element = elements[0].children;
                console.log('ITEMS TO LOOP',loop_element.length)
                let points = [];
                for(let i = 0; i < loop_element.length; i++){
                    points.push(loop_element[i].attributes[0].value);
                }
                points = JSON.stringify(points);
                console.log(points)
                
                if(points && svg_element){
                    let params = {
                        type: type,
                        signature_svg: points,
                    }
                    this.saveClientSignature(params)
                    .then(()=>{
                        this.loadClientSignature(type)
                        .then(()=>{
                            this.is_saving = false;
                            this.$bvModal.hide('signatureModal');
                        })
                    })
                }
            }, 1500);
        },
        renderSignature(){
            //alert('Render')
            //console.log('Signature points', JSON.parse(this.client_signature.signature_svg))
            this.$refs.signaturePad.fromData(JSON.parse(this.client_signature.signature_svg))
        },
        changeMode(new_mode = null){
            if(this.$refs.signaturePad != undefined){
                this.$refs.signaturePad.clearSignature();
            }
            

            if(new_mode != null){
                //* overide toggle with specified mode
                this.mode = new_mode;
                return;
            }

            //* no override mode, just toggle instead
            if(this.mode == 'signature'){
                this.mode = 'initial';
            }
            else{
                this.mode = 'signature';
            }
        }
    },
    mounted(){
        console.log('Waiting ')
        setTimeout(()=>{
            this.hasMounted = true;
            if(this.$refs.signaturePad == undefined){
                alert(`Is undefined --> ${this.hasMounted}`)
            }
            else{
                // call resizeCanvas to fix sizing issue on load
                this.$refs.signaturePad.resizeCanvas();
                //this.renderSignature();
            }
        }, 1000);
        /*this.loadClientSignature('signature');
        this.loadClientSignature('initial');*/
    },
}
</script>

<style>

</style>